import React, { useEffect, useState } from 'react';
import CollegePageContainer from '../Container/CollegePageContainer';
import { connect } from 'react-redux';
import SignContractContent from './SignContractContent';
import { pdfjs } from "react-pdf";
import "./pdf.css";
import { updateInstitutionInfo } from '../../redux/college/college.actions';
import { API } from '../../API';
import { notify } from 'react-notify-toast';

const SignContract = (props) => {
  const { updateInstInfo, user } = props
  const [ fileUrl, setFileUrl ] = useState("")

  useEffect(() => {
    API.getInstitutionDataById(user.institution_id || user.institution)
      .then((res) => {
        const inst = res?.data;
        const isAcceptedContract = (inst?.is_childcare_centre && inst?.new_pricing_contract?.is_accepted) || (!inst?.is_childcare_centre && inst?.new_pricing_contract?.is_accepted)
        if (isAcceptedContract) {
          updateInstInfo(inst);
          notify.show("The contract was accepted")
          props.history.push(`/NavigateToFileViewer?fileurl=${inst?.is_childcare_centre ? inst.new_pricing_contract.url : inst.new_pricing_contract.url}`)
        } else {
          API.getContractUrlWithoutAccepting()
            .then((response) => {
              setFileUrl(response?.data?.data)
            }).catch((error) => {
              console.log(error)
            })
        }
      })
      .catch(err => {
        console.log('err', err)
      })

    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);

  return (
    <CollegePageContainer
      header="Education Provider Services Agreement (Terms and Conditions)"
      user={props.user}
    >
      <div>
        <SignContractContent
          pdfFile={fileUrl}
          updateInstInfo={updateInstInfo}
          user={user}
        />
        </div>
    </CollegePageContainer>
  )
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
  };
}

const mapDispatchToProps = (dispatch) => ({
  updateInstInfo: (inst) => dispatch(updateInstitutionInfo(inst)),
})


export default connect(mapStateToProps, mapDispatchToProps)(SignContract);
